export default [
  {
    text: 'Mais Barato (preço)',
    id: 1,
    value: 'CHEAPEST',
  },
  {
    text: 'Mais Barato (custo)',
    id: 3,
    value: 'CHEAPEST_PROVIDER',
  },
  {
    text: 'Mais Rápido',
    id: 2,
    value: 'FASTEST',
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/enum/EnumConditionalNormal.js